import { IInvoice, InvoiceStatus } from "@wingspanhq/payments/dist/interfaces";
import { TaxWithholdingSettings } from "@wingspanhq/wingspan-api-sdk";

export const getInvoiceTaxWithholdings = (
  taxWithholdingSettings: TaxWithholdingSettings | undefined,
  invoice: IInvoice,
  netIncome: number,
  hasActiveTaxWithholdingAccount: boolean
): {
  amount: number;
  rate: number;
} => {
  if (invoice.status === InvoiceStatus.Paid) {
    return {
      amount: invoice.withholdings?.tax?.amountWithheld || 0,
      rate: invoice.withholdings?.tax?.rate || 0
    };
  }

  const isActive =
    hasActiveTaxWithholdingAccount &&
    taxWithholdingSettings?.isEnabled === true;

  const defaultRate = isActive
    ? taxWithholdingSettings?.withholdingRate || 0
    : 0;

  return {
    amount: netIncome * (defaultRate / 100),
    rate: defaultRate
  };
};
